import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

/**
 * This function shows a toast with an error message.
 * @param {string} message - The message to show.
 */
export const showErrorToast = (message) => {
  // Display the error message in a toast
  toast.error(message, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
  });
};

/**
 * This function shows a toast with a success message.
 * @param {string} message - The message to show.
 */
export const showSuccessToast = (message) => {
  toast.success(message, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
  });
};



